function formatMMYYYYFromDate(isoDateString) {
  const dateObject = new Date(isoDateString);
  if (isNaN(dateObject.getTime())) {
    // Handle invalid date format
    return null;
  }

  const month = (dateObject.getUTCMonth() + 1).toString().padStart(2, "0");
  const year = dateObject.getUTCFullYear();
  return `${month}/${year}`;
}

function getNumberSuffix(num) {
  if (num >= 11 && num <= 13) return "th";
  switch (num % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
}

export { formatMMYYYYFromDate, getNumberSuffix };
